import React, { useState } from 'react';
import { Box, Typography, Link, Tooltip } from '@mui/material';
import { Launch } from '@mui/icons-material';
import SKUModal from './SKUModal';

const ClickableSKU = ({ sku, productName, inline = false, showIcon = true }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    setModalOpen(true);
  };

  if (inline) {
    return (
      <>
        <Tooltip title="Click to view product details" arrow>
          <Link
            component="button"
            variant="body2"
            onClick={handleClick}
            sx={{
              color: 'primary.main',
              textDecoration: 'none',
              fontFamily: 'monospace',
              fontWeight: 600,
              '&:hover': {
                textDecoration: 'underline',
                backgroundColor: 'rgba(71, 189, 198, 0.1)',
                borderRadius: 1,
                px: 0.5
              }
            }}
          >
            {sku}
          </Link>
        </Tooltip>
        {productName && (
          <Typography variant="body2" component="span" sx={{ ml: 1, color: 'text.secondary' }}>
            ({productName})
          </Typography>
        )}
        <SKUModal sku={sku} open={modalOpen} onClose={() => setModalOpen(false)} />
      </>
    );
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          p: 1,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.paper',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          '&:hover': {
            borderColor: 'primary.main',
            backgroundColor: 'rgba(71, 189, 198, 0.05)',
            transform: 'translateY(-1px)',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }
        }}
        onClick={handleClick}
      >
        <Box>
          <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 600, color: 'primary.main' }}>
            {sku}
          </Typography>
          {productName && (
            <Typography variant="caption" color="text.secondary">
              {productName}
            </Typography>
          )}
        </Box>
        
        {showIcon && (
          <Launch sx={{ fontSize: 16, color: 'text.secondary' }} />
        )}
      </Box>
      
      <SKUModal sku={sku} open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
};

export default ClickableSKU;
